export default __webpack_public_path__ + "static/media/ProximaNova-Bold.75321e44.woff2";